  import React, { useState } from 'react';
import Navbar from "../components/Navbar";
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  ClockIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => { 
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    // Clear status when user starts typing
    if (status.type) setStatus({ type: '', message: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      // Auto-generate Date
      const today = new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });

      // Replace YOUR_API_ID with your SheetDB API endpoint
      const response = await fetch("https://sheetdb.io/api/v1/2gxu3u9ngupzh", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: [
            {
              "Full Name": formData.name,
              "Email": formData.email,
              "Phone": formData.phone,
              "Message": formData.message,
              "Date": today,
            },
          ],
        }),
      });

      if (response.ok) {
        setStatus({ 
          type: 'success', 
          message: 'Message saved successfully! ✅' 
        });
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setStatus({ 
          type: 'error', 
          message: 'Something went wrong ❌. Please try again!' 
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus({ 
        type: 'error', 
        message: 'Network error ❌. Please check your connection.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-orange-50 py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {/* Hero Section */}
          <div className="text-center mb-12 md:mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4 md:mb-6 drop-shadow-sm">
              Contact Us
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto px-4">
              Get in touch with our team of Sports Experts Infra. We're here to help you create world-class sports facilities.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 mb-16 md:mb-20">
            {/* Contact Information */}
            <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-6 md:mb-8">Get in Touch</h2>
              <div className="space-y-6 md:space-y-8">
                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    <MapPinIcon className="h-5 w-5 md:h-6 md:w-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg md:text-xl mb-1 md:mb-2 text-gray-800">Address</h3>
                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                      Plot No 31<br />
                      Prem Nagar, Erragadda, Sanathnagar,<br />
                      Hyderabad - 500018, INDIA
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    <PhoneIcon className="h-5 w-5 md:h-6 md:w-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg md:text-xl mb-1 md:mb-2 text-gray-800">Phone</h3>
                    <p className="text-sm md:text-base text-gray-600">+91 8400740120, +91 9936175966</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    <EnvelopeIcon className="h-5 w-5 md:h-6 md:w-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg md:text-xl mb-1 md:mb-2 text-gray-800">Email</h3>
                    <p className="text-sm md:text-base text-gray-600">sportsexpertsinfra@gmail.com</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    <ClockIcon className="h-5 w-5 md:h-6 md:w-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg md:text-xl mb-1 md:mb-2 text-gray-800">Business Hours</h3>
                    <p className="text-sm md:text-base text-gray-600">Monday - Sunday: 10:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-6 md:mb-8">Send us a Message</h2>
              
              {/* Status Message */}
              {status.type && (
                <div className={`mb-6 p-4 rounded-lg flex items-center gap-3 ${
                  status.type === 'success' 
                    ? 'bg-green-50 text-green-800 border border-green-200' 
                    : 'bg-red-50 text-red-800 border border-red-200'
                }`}>
                  {status.type === 'success' ? (
                    <CheckCircleIcon className="h-5 w-5 text-green-600" />
                  ) : (
                    <ExclamationTriangleIcon className="h-5 w-5 text-red-600" />
                  )}
                  <span className="font-medium text-sm md:text-base">{status.message}</span>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-sm md:text-base">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 hover:border-orange-300 text-sm md:text-base"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-sm md:text-base">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 hover:border-orange-300 text-sm md:text-base"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-sm md:text-base">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91-XXXXXXXXXX"
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 hover:border-orange-300 text-sm md:text-base"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-gray-700 font-semibold mb-1 md:mb-2 text-sm md:text-base">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project or inquiry..."
                    className="w-full px-3 md:px-4 py-2 md:py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 hover:border-orange-300 resize-none text-sm md:text-base"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full py-3 md:py-4 font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl text-sm md:text-base ${
                    loading 
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                      : 'bg-green-800 text-white hover:bg-green-900 hover:scale-105'
                  }`}
                >
                  {loading ? 'Sending Message...' : 'Send Message'}
                </button>
                
                
                
              </form>
            </div>
          </div>

          {/* Embedded Google Map */}
          <div className="w-full h-[300px] md:h-[450px] rounded-2xl overflow-hidden shadow-xl border-4 border-white">
           <div className="w-full h-[400px] rounded-2xl overflow-hidden shadow-lg">
  <iframe
    title="Company Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15223.949705634113!2d78.44108889999998!3d17.4603159!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90e30913f12b%3A0x43f41edb3a4c560!2sErragadda!5e0!3m2!1sen!2sin!4v1770968542179!5m2!1sen!2sin"
    className="w-full h-full"
    style={{ border: 0 }}
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
